module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottom-footer text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-12"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h3', [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": "Gallery"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "contact-list"
  }, [_c('li', [_c('p', [_vm._v("©2019 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Gallery")]), _vm._v(" All Rights Reserved")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "footer-widget",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "widget-title foot-links"
  }, [_c('h3', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/demos"
    }
  }, [_vm._v("Demos")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/go/features"
    }
  }, [_vm._v("Features")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/go/pricing"
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Email: info@lookbookgallery.com")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" Phone: 07086428158")])]), _vm._v(" "), _c('div', {
    staticClass: "social-block",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-f"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])])]), _vm._v(" "), _c('hr')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07bf1a22"}!./src/pages/MainFooter/template.html
// module id = 246
// module chunks = 0